import { transition, trigger, useAnimation } from '@angular/animations';
import {
  Component,
  ContentChild,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  fadeInStaticPositionAnimation,
  fadeOutStaticPositionAnimation,
} from '../../../../../shared/animations/index';
import { LoadingIndicatorStyles } from '../../../../ui-elements/constants/loading-indicator-styles.constant';
import { EntityLabelsInterface } from '../../../interfaces/entity-labels.interface';
import { TableListItemComponent } from './table-list-item/table-list-item.component';

@Component({
  selector: 'table-list',
  standalone: false,
  templateUrl: './table-list.component.html',
  styleUrls: ['./table-list.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('fadeInOutStaticPositionAnimation', [
      transition(':enter', [
        useAnimation(fadeInStaticPositionAnimation, {
          params: {
            duration: '0.2s',
            delay: '0s',
          },
        }),
      ]),
      transition(':leave', [
        useAnimation(fadeOutStaticPositionAnimation, {
          params: {
            duration: '0.2s',
            delay: '0s',
          },
        }),
      ]),
    ]),
  ],
})
export class TableListComponent {
  @ViewChild('removeAllItemsAction') removeAllItemsActionElement: ElementRef;

  @ContentChild('header') headerElement: ElementRef;

  @ContentChildren(TableListItemComponent)
  items!: QueryList<TableListItemComponent>;

  @Input() processing: boolean = false;
  @Input() message: string = null;
  @Input('displayRemoveAll') displayRemoveAllInput: boolean = true;
  @Input() displayItemCount: boolean = true;
  @Input() entityLabels: EntityLabelsInterface;
  @Input('classes') cssClasses: Array<string> = [];

  @Output('removeAll') removeAllEvent: EventEmitter<Array<string>> =
    new EventEmitter<Array<string>>();

  get displayRemoveAll() {
    return this.displayRemoveAllInput && this.items.length;
  }

  get displayHeader() {
    return !!this.headerElement;
  }

  get displayFooter() {
    return this.displayRemoveAllInput || this.displayItemCount;
  }

  loadingIndicatorStyles = LoadingIndicatorStyles;

  handleRemoveAllItemsAction() {
    this.removeAllItemsActionElement.nativeElement.blur();

    this.removeAllItems();
  }

  removeAllItems() {
    const itemIdsToRemove = this.items?.toArray().map(item => item.itemId);
    this.removeAllEvent.emit(itemIdsToRemove);
  }
}
